import {ShapeCommand} from '../../commands.template';
declare const mxUtils: any;

export class FlowlineChangeInteractionStyleCommand extends ShapeCommand {
  services: any;
  reverseData: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = graph.model.getCell(`${this.object.flowlineMxKey}-ian`);

    this.reverseData = {
      style: {
        backgroundColor: graph.getCellStyle(cell).fillColor || '#ffffff',
        lineColor: graph.getCellStyle(cell).strokeColor
      }
    };

    const updatedStyle = {
      ...this.reverseData.style,
      ...this.object.style
    };

    const action = {
      changeInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        style: updatedStyle
      }
    };

    this.setStyles(updatedStyle);
    this.services.diagramUpdateSvc.update(action);
  }

  public reverse() {
    super.reverse();

    const action = {
      changeInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        style: this.reverseData.style
      }
    };

    this.setStyles(this.reverseData.style);
    this.services.diagramUpdateSvc.update(action);
  }

  private setStyles(styleObj) {
    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = graph.model.getCell(`${this.object.flowlineMxKey}-ian`);

    graph
      .getModel()
      .setStyle(cell, mxUtils.setStyle(cell.style, 'fillColor', styleObj.backgroundColor));
    graph
      .getModel()
      .setStyle(cell, mxUtils.setStyle(cell.style, 'strokeColor', styleObj.lineColor));
  }
}
